/* src/app/modules/portal/components/system-overview-syngovia/system-overview-syngovia.component.scss */
/*# sourceMappingURL=system-overview-syngovia.component.css.map */
